export default __webpack_public_path__ + "static/media/card-4.46a875a4.webp";